import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate } from 'react-router-dom';

const BackButton: React.FC = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBack}
            sx={{ color: 'black', backgroundColor: '#E0E0E0' }}
        >
            Back
        </Button>
    );
};

export default BackButton;